<template>
    <div class="app-window" ref="window" :class="{ 'not-focused': !STATE_request.window.onFocus }" :style="{'z-index': STATE_request.window.zIndex}">
        <div class="resizable-edge" style="position: absolute; background-color: transparent; right: -8px; width: 30px; height: 15px; bottom: -8px; z-index: 3;"></div>
        <div class="resizable-edge" style="position: absolute; background-color: transparent; right: -8px; bottom: -5px; height:25px; width: 15px; z-index: 3;"></div>
        <div class="window__header">
            <window-header @showLog="showLog = !showLog" :STATE_request="STATE_request"></window-header>
        </div>
        <form class="window__body" autocomplete="off">
            <app-container-loading :show="STATE_request.loading.show" :text="STATE_request.loading.text"></app-container-loading>
            <app-request ref="request" v-show="!STATE_request.loading.show && !showLog" :request="STATE_request.request"></app-request>
            <app-request-log :requestId="STATE_request.requestId" v-if="showLog" @closeRequestLog="showLog = false"></app-request-log>
        </form>
    </div>
</template>

<script>
    import { mapMutations, mapState, mapActions } from 'vuex'
    import interact from 'interactjs'
    import _ from 'lodash'
    import Request from './Request/Request.vue'

    import WindowHeader from './WindowHeader.vue'
    import RequestLogComponent from './Request/RequestLog.vue'

    export default {
        props: ['STATE_request'],
        data(){
            return {
                windowInteractInstance: null,
                windowOnfocus: true,
                showLog: false
            }
        },
        components: {
            'app-request': Request,
            'app-request-log': RequestLogComponent,
            'window-header': WindowHeader
        },
        methods: {
            ...mapActions("toast", ["showToast", "showError"]),
            focus(event){
                if (
                    this.$refs.window && 
                    (this.$refs.window !== event.target && !this.$refs.window.contains(event.target))
                ){
                    if(this.hasSomeParentClass(event.target,'popover-content')){
                        this.STATE_request.$update({
                            where: this.STATE_request.id,
                            data: {
                                window: {
                                    ...this.STATE_request.window,
                                    zIndex: _.max(_.map(this.VXORM.STATE_Request.all(),(STATE_request) => STATE_request.window.zIndex),(STATE_request) => {
                                        return STATE_request.window.zIndex
                                    }) + 1,
                                    onFocus: true
                                }
                            }
                        })
                        return
                    }
                    this.STATE_request.$update({
                        where: this.STATE_request.id,
                        data: {
                            window: {
                                ...this.STATE_request.window,
                                onFocus: false
                            }
                        }
                    })
                } 
                else {
                    this.STATE_request.$update({
                        where: this.STATE_request.id,
                        data: {
                            window: {
                                ...this.STATE_request.window,
                                zIndex: _.max(_.map(this.VXORM.STATE_Request.all(),(STATE_request) => STATE_request.window.zIndex),(STATE_request) => {
                                    return STATE_request.window.zIndex
                                }) + 1,
                                onFocus: true
                            }
                        }
                    })
                }
            },
            hasSomeParentClass(element, classname) {
                if (element.className && element.className.split(' ').indexOf(classname) >= 0) return true
                return element.parentNode && this.hasSomeParentClass(element.parentNode, classname)
            }
        },
        mounted(){
            const vm = this
            if(!vm.windowInteractInstance){
                vm.windowInteractInstance = interact(vm.$refs.window).draggable({
                    allowFrom: '.window__header',
                    ignoreFrom: '.close-button, .chat-button',
                    onmove(event){
                        let target = event.target,
                            // keep the dragged position in the data-x/data-y attributes
                            x = (parseFloat(target.getAttribute('data-x')) || 20) + event.dx,
                            y = (parseFloat(target.getAttribute('data-y')) || 20) + event.dy;

                        // translate the element
                        target.style.left = x + 'px'
                        target.style.top = y + 'px'

                        // update the posiion attributes
                        target.setAttribute('data-x', x);
                        target.setAttribute('data-y', y);
                    },
                    onend  : function (event) {
                        vm.VXORM.STATE_Request.update({
                            where: vm.STATE_request.id,
                            data: {
                                window: {
                                    ...vm.STATE_request.window,
                                    x: (parseFloat(event.target.getAttribute('data-x')) || 20) + event.dx,
                                    y: (parseFloat(event.target.getAttribute('data-y')) || 20) + event.dy
                                }
                            }
                        })
                    }
                }).resizable({
                    edges: { left: false, right: '.resizable-edge', bottom: '.resizable-edge', top: false },
                    restrictSize: {
                        min: { width: 640, height: 600 },
                    }
                }).on('resizemove', function (event) {
                    let target = event.target,
                        x = (parseFloat(target.getAttribute('data-x')) || 20),
                        y = (parseFloat(target.getAttribute('data-y')) || 20);
                    // update the element's style
                    target.style.width  = event.rect.width + 'px';
                    target.style.height = event.rect.height + 'px';

                    // translate when resizing from top or left edges
                    x += event.deltaRect.left;
                    y += event.deltaRect.top;

                    target.style.left = x + 'px'
                    target.style.top = y + 'px'

                    target.setAttribute('data-x', x)
                    target.setAttribute('data-y', y)
                })

                let target = this.$refs.window

                // translate the element
                target.style.left = this.STATE_request.window.x + 'px'
                target.style.top = this.STATE_request.window.y + 'px'

                // update the posiion attributes
                target.setAttribute('data-x', this.STATE_request.window.x);
                target.setAttribute('data-y', this.STATE_request.window.y);
            }

            document.addEventListener('mousedown', this.focus)
        },
        beforeDestroy(){
            // if(this.windowInteractInstance){
            //     this.windowInteractInstance.unset()
            // }
            document.removeEventListener('mousedown', this.focus)
        }
    }
</script>

<style lang="scss" scoped>
    .app-window {
        position: absolute;
        width: 640px;
        height: 600px;
        background-color: var(--bg-color--2);
        border: 1px solid var(--bg-color--2);
        display: flex;
        flex-direction: column;
        box-shadow: var(--popover-shadow);
        pointer-events: initial;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        top: 20px;
        left: 20px;

        .window {
            width:100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            position: relative;
        }
        .window__header {
            display: flex;
            flex-shrink: 0;
            flex-direction: row;
            height: 40px;
            align-items: center;
            background-color: var(--bg-color--5);
            &:hover {
                background-color: var(--bg-color--8);
            }
            h3, span {
                position: relative;
                top: -1px;
            }
            span {
                color: var(--font-color--7);
                font-size: 12px;
            }
            span.window__spacer {
                margin: 0 5px;
            }
            span.window__author, span.window__time {
                color: var(--font-color--primary);
                font-weight: 600;
            }
            .window__title {
                color: var(--font-color--terciary);
                margin-left: 8px;
                margin-right: 5px;
                font-size: 12px;
            }
            .close-button, .chat-button {
                height: 30px;
                width: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: var(--bg-color--9);
                color: var(--font-color--7);
                margin-left: 1px;
                i {
                    font-weight: 900;
                    font-size: 18px;
                    position: relative;
                    top: -1px;
                }
                &:hover {
                    background-color: var(--bg-color--10);
                }
            }
            .chat-button i {
                font-size: 16px;
            }
        }
        .window__body {
            display: flex;
            flex-grow: 1;
            background-color: var(--bg-color--6);
        }
    }

    .not-focused {
        opacity: 0.9;
        filter: blur(.5)
    }
</style>
